// extracted by mini-css-extract-plugin
export default {"reviewContainer":"annualReview_reviewContainer__zKwgB","reviewContent":"annualReview_reviewContent__d-bi9","reviewText":"annualReview_reviewText__NMRMs"};